import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '@nxsys/store';

/**
 * `paramFilter` for an employer search select: a bureau employer is only
 * offered their own companies. Memoised because AppSelectSync re-runs its
 * search effect whenever `paramFilter` changes identity.
 */
export const useEmployerSearchScope = () => {
  const { isBureauEmployer, user } = useSelector(
    (state: AppState) => state.appStore,
  );
  const companyUserIds = user?.companyUserIds;

  return useMemo(
    () =>
      isBureauEmployer ? { companyUserIds: companyUserIds || [] } : undefined,
    [isBureauEmployer, companyUserIds],
  );
};
